import VolunteerDetails from "./VolunteerDetails";

export default VolunteerDetails;